import events from '../constants/events';

import LazyLoad from 'vanilla-lazyload';

const lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy'
});

window.addEventListener(events.LOAD_IMAGES, (e) => {
  const { images } = e.detail;

  if (images && images.length) {
    for (let i = 0; i < images.length; i++) {
      lazyLoadInstance.load(images[i]);
    }
  }
});

window.addEventListener(events.AJAX_UPDATED, () => {
  if (lazyLoadInstance) {
    lazyLoadInstance.update();
  }
});

window.addEventListener(events.FILTER_CONTENT_UPDATED, () => {
  if (lazyLoadInstance) {
    lazyLoadInstance.update();
  }
});

window.addEventListener(events.OVERLAY_OPENED, () => {
  if (lazyLoadInstance) {
    lazyLoadInstance.update();
  }
});

window.addEventListener(events.PRODUCT_IMAGES_UPDATED, () => {
  if (lazyLoadInstance) {
    lazyLoadInstance.update();
  }
});

// Lazy load images in the Shopify theme editor
document.addEventListener('shopify:section:load', () => {
  if (lazyLoadInstance) {
    lazyLoadInstance.update();
  }
});